export type FormInputTypes = "input" | "select" | "checkbox" | "text";

export type FormInputTypeAssignedAttribute =
  | null
  | "users_first_name"
  | "users_last_name"
  | "users_email"
  | "users_phone";

export function isFormInputTypeAssignedAttribute(
  assignedAttribute: string,
): assignedAttribute is FormInputTypeAssignedAttribute {
  return (
    assignedAttribute === null ||
    assignedAttribute === "users_first_name" ||
    assignedAttribute === "users_last_name" ||
    assignedAttribute === "users_email" ||
    assignedAttribute === "users_phone"
  );
}

type FormSelectTypeAssignedAttribute = null;
type FormCheckboxTypeAssignedAttribute = null;
type FormTextTypeAssignedAttribute = null;

export type FormInputAssignedAttribute = FormInputTypeAssignedAttribute | FormSelectTypeAssignedAttribute;

export type FormInput = {
  form_id: number;
  id: number;
  label: string;
  required: boolean;
  assigned_attribute: FormInputAssignedAttribute;
  type: FormInputTypes;
  help_text: string;
  row: number;
  column: number;
  values: string[] | null;
};
